import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddCategory } from "../../Category.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

const useAddCategory = () => {
  const [formData, setFormData] = useState<IAddCategory>({
    category: "",
    icon: null,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { id, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    console.log(file)
    if (file) {
      setFormData((prevState) => ({
        ...prevState,
        icon: file,
      }));
    }
  };
 
  const handleSubmit: SubmitHandler<IAddCategory> = async () => {
    const formDataToSend = new FormData();
    formDataToSend.append("category", formData.category);
    if (formData.icon) {

      formDataToSend.append("imageUrl", formData.icon);
    }
    console.log(formData.icon)

    try {
      setLoading(true);
      const response = await ApiService({
        method: "POST",
        endpoint: `${apiPaths.getAllCategories}`,
        data: formDataToSend,
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast.success("Category added successfully", {
        duration: 10000,
      });
      navigate("/category");
    } catch (error) {
      toast.error("Error adding category", {
        duration: 10000,
      });
      console.error("Error adding category:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/category");
  };

  return {
    loading,
    formData,
    handleChange,
    handleFileChange,
    handleSubmit,
    handleCancel,
  };
};

export default useAddCategory;
